import React from 'react';
import { motion } from 'framer-motion';

const sources = [
  { label: "Karpathy's US Job Market Visualizer", icon: "🔬" },
  { label: "BLS Occupational Outlook Handbook (2024-2034)", icon: "📊" },
  { label: "Anthropic Labor Market Impacts Research (March 2026)", icon: "🤖" }
];

const Authority = () => {
  return (
    <section className="bg-jeruel-offwhite py-16 px-4 sm:px-6 lg:px-8 border-t border-jeruel-gray">
      <div className="max-w-6xl mx-auto">
        <motion.div 
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="rounded-2xl bg-white border border-jeruel-gray shadow-sm p-8 sm:p-10"
        >
          <div className="flex flex-col lg:flex-row gap-10 lg:gap-16">
            
            <div className="flex-1">
              <p className="text-xs font-bold text-jeruel-primary uppercase tracking-widest mb-5">Data Sources</p>
              <div className="space-y-3">
                {sources.map((s, i) => (
                  <div key={i} className="flex items-center gap-3">
                    <span className="text-lg">{s.icon}</span>
                    <span className="text-sm font-medium text-gray-600">{s.label}</span>
                  </div>
                ))}
              </div>
            </div>

            <div className="lg:w-px lg:h-auto bg-jeruel-gray" />

            <div className="flex-1">
              <p className="text-xs font-bold text-jeruel-primary uppercase tracking-widest mb-5">Prepared by</p>
              <p className="text-lg font-bold text-jeruel-dark mb-2">Jeruel Global</p>
              <p className="text-sm text-gray-500 leading-relaxed">
                We are the training partner to Fortune 500 manufacturing organizations across North America. We specialize in maintenance workforce development and AI readiness.
              </p>
            </div>

          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Authority;